/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './config-initializer.module';
export { CONFIG_INITIALIZER, ConfigInitializer } from './config-initializer';
export * from './config-initializer.service';
